// @flow

export default {
  header: 100,
  navMobile: 200,
  video: 300,
};
